import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/useStore';
import { HelpDrawer } from '../HelpDrawer';
import { CurrencySelector } from '../CurrencySelector';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Calendar } from 'lucide-react';

export function TopBar({ title, actions, helpSection }) {
  const { t, i18n } = useTranslation();
  const { language, setLanguage, selectedDate, setSelectedDate } = useAppStore();

  const handleLanguageChange = (value) => {
    setLanguage(value);
    i18n.changeLanguage(value);
  };

  return (
    <header 
      className="sticky top-0 z-30 h-14 glass flex items-center justify-between px-6"
      data-testid="topbar"
    >
      <div className="flex items-center gap-4">
        <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
        
        {/* Date selector for relevant pages */}
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Calendar className="h-4 w-4" />
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="bg-transparent border-none text-sm focus:outline-none focus:ring-0"
            data-testid="date-selector"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        {helpSection && <HelpDrawer section={helpSection} />}

        {/* Currency Selector */}
        <CurrencySelector compact />

        {/* Language Selector */}
        <Select value={language} onValueChange={handleLanguageChange}>
          <SelectTrigger className="w-20 h-8 text-xs" data-testid="language-selector">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="es">ES</SelectItem>
            <SelectItem value="en">EN</SelectItem>
          </SelectContent>
        </Select>

        {/* Page Actions */}
        {actions}
      </div>
    </header>
  );
}
